<template>
  <div class="app-container" :style="{ '--current-color': theme }">

    <!-- 顶部bar -->
    <div class="top-bar">
      <Navbar/>
    </div>

    <div style="height: 50px"></div>

    <div class="body-box">
      <div class="body-left">
        <Sidebar/>
      </div>
      <div class="body-right">
        <AppMain/>
      </div>
    </div>

  </div>
</template>

<script>
import {AppMain, Navbar, Sidebar} from './components';
import {mapState} from 'vuex';

export default {
  name: 'Layout',
  components: {
    AppMain,
    Navbar,
    Sidebar,
  },
  computed: {
    ...mapState({
      theme: (state) => state.settings.theme,
    }),
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.app-container {
  position: relative;

  .top-bar {
    position: absolute;
    width: 100%;
    height: 50px;
    left: 0;
    top: 0;
    z-index: 500;
  }

  .body-box {
    width: 100%;
    height: calc(100vh - 50px);
    z-index: 400;
    background: rgb(245, 245, 245);


    display: flex;

    .body-left {
      width: 208px;
      height: calc(100vh - 50px);
    }

    .body-right {
      flex: 1;
      width: 0;
      height: 100%;
    }
  }
}

</style>
